import { getClampedPercent } from '../Construction.utils';

export const getInitialDrawDraft = () => ({});

const getLineDraft = (draft, lineId) => draft[lineId] ?? {};

export const getRequestedAmount = (draft, lineId) =>
  getLineDraft(draft, lineId).requestedAmount ?? '';

export const getPercentComplete = (draft, lineId) =>
  getLineDraft(draft, lineId).percentComplete ?? '';

export const getIsLineOverRemaining = ({ draft, line }) => {
  const requested = Number(getRequestedAmount(draft, line.id));

  return requested > 0 && requested > (line.remaining ?? 0);
};

export const getHasRequestedLine = draft =>
  Object.values(draft).some(entry => Number(entry?.requestedAmount) > 0);

export const getHasOverRemainingLine = ({ draft, budgetLines = [] }) =>
  budgetLines.some(line => getIsLineOverRemaining({ draft, line }));

// Only lines the user actually entered a positive amount for are sent — the API rejects a zero/negative
// line amount, and a draw with no lines at all ("Add Draw Request" POSTing {}) is the original defect.
export const toDrawRequestPayload = ({ budgetLines = [], draft, retainagePercent }) => ({
  retainagePercent: Number(retainagePercent) || 0,
  lineItems: budgetLines
    .filter(line => Number(getRequestedAmount(draft, line.id)) > 0)
    .map(line => ({
      budgetLineItemId: line.id,
      requestedAmount: Number(getRequestedAmount(draft, line.id)) || 0,
      percentComplete: getClampedPercent(Number(getPercentComplete(draft, line.id)) || 0),
    })),
});
